import { handleFailure } from "@skve/components";

import { installPwa } from "@/pwa";

export const apiUrl = "/api";
export const initialUrl = `${apiUrl}/initial`;

const vapidPublicKey =
  "BBkre6jYvH6H2KgacgF2lZ5ZXMgNOSdD0iw5X113-RQe64bO81MP4wCHQAUfkPfbKsHa5kx0DZSOGLQvEfEsKSE";

async function sendSubscriptionToServer(subscription) {
  const result = await fetch(`${apiUrl}/subscription`, {
    method: "POST",
    body: JSON.stringify(subscription),
    headers: { "content-type": "application/json" },
  });

  if (result.status !== 201) {
    throw new Error("Das Push Notification Abo konnte nicht angelegt werden.");
  }
}

async function removeSubscriptionFromServer(subscription) {
  const id = btoa(subscription.endpoint);
  const result = await fetch(`${apiUrl}/subscription/${id}`, {
    method: "DELETE",
  });

  if (result.status !== 204) {
    throw new Error("Das Push Notification Abo konnte nicht gelöscht werden.");
  }
}

export function performLogin(provider, redirectPath) {
  const q = redirectPath ? `?to=${encodeURIComponent(redirectPath)}` : "";
  location.href = `${apiUrl}/auth/${provider}${q}`;
}

export async function performLogout() {
  const res = await fetch(`${apiUrl}/logout`, {
    method: "POST",
    headers: {
      "content-type": "application/json",
    },
    body: JSON.stringify({}),
  });

  if (!res.ok) {
    const response = await res.json();
    return handleFailure(response);
  }

  location.pathname = "/";
}

export function setupPwa() {
  if ("serviceWorker" in navigator) {
    installPwa();
  }
}

export function useAuthenticatedResource(source) {
  return source;
}

export function establishWebSocket() {
  const ws = new WebSocket(`${apiUrl}/events`);
  return Promise.resolve(ws);
}

export function canUpdateApp(current, actual) {
  return current !== actual;
}

export function isPushNotificationSupported() {
  return "Notification" in window && "serviceWorker" in navigator;
}

export async function isPushNotificationGranted() {
  return isPushNotificationSupported() && Notification.permission === "granted";
}

export async function requestPushNotificationPermission() {
  if (!isPushNotificationSupported()) {
    return false;
  }

  await Notification.requestPermission();
  return Notification.permission === "granted";
}

export async function getPushNotificationSubscription() {
  if (!isPushNotificationSupported()) {
    return false;
  }

  const swRegistration = await navigator.serviceWorker.ready;
  const subscription = await swRegistration.pushManager.getSubscription();

  if (subscription) {
    const id = btoa(subscription.endpoint);
    const result = await fetch(`${apiUrl}/subscription/${id}`);
    return result.status === 200;
  }

  return false;
}

export async function setPushNotificationSubscription(enabled) {
  const swRegistration = await navigator.serviceWorker.ready;
  const subscription = await swRegistration.pushManager.getSubscription();

  if (!enabled) {
    if (subscription) {
      await removeSubscriptionFromServer(subscription);
      await subscription.unsubscribe();
    }
  } else if (subscription) {
    await sendSubscriptionToServer(subscription);
  } else {
    const newSubscription = await swRegistration.pushManager.subscribe({
      userVisibleOnly: true,
      applicationServerKey: vapidPublicKey,
    });
    await sendSubscriptionToServer(newSubscription);
  }
}

function getSelectedThemeColor(theme) {
  return theme === "dark" ? "#040f16" : "#f0f0f0";
}

function changeElement(selector, attr, value) {
  document.querySelector(selector).setAttribute(attr, value);
}

export function applyTheme(theme) {
  const color = getSelectedThemeColor(theme);
  // dynamic color is broken on Android right now:
  // https://issuetracker.google.com/issues/554055703
  // update; has been fixed as of Sep 21 2026 (Chrome 153.0.8010.52)
  changeElement("meta[name=msapplication-TileColor]", "content", color);
  changeElement("meta[name=theme-color]", "content", color);
  changeElement("link[rel=mask-icon]", "color", color);
}
